<header class="section-header">
  <h2>پروفایل سرعت</h2>
  <span>توزیع سرعت در چهار بازه</span>
</header>
<app-chart [context]="chartContext"></app-chart>
<div class="legend" aria-label="بازه‌های سرعت بر حسب کیلومتر بر ساعت">
  <span *ngFor="let band of bands">
    <i class="dot" [ngClass]="band.cssClass" aria-hidden="true"></i>
    {{ band.label }}
  </span>
</div>
